import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
    is3dpayment: false as boolean,
}

export const paymentReducer = createSlice({
    name: "payment",
    initialState,
    reducers: {
         set3dpayment: (state,{payload} : PayloadAction<boolean>)=>{
            state.is3dpayment = payload;
          }
               
    },
});


export const { set3dpayment } = paymentReducer.actions
export default paymentReducer.reducer;